export enum DealTagStyle {
  none = 'none',
  dealTimer = 'deal_timer',
  gray = 'gray',
}

export type Image = {
  alt?: string;
  dimensions?: {
    height: number;
    width: number;
  };
  url: string;
};

export type Copy = {
  text?: string;
  type?: string;
}[];

export interface ProductStripDealsItem {
  tag_style?: DealTagStyle;
  tag_text?: string;
  image?: Image;
  product_id?: string;
  copy?: Copy;
  link?: string;
}

export interface ProductStripDealsType {
  id?: string;
  slice_type?: RedesignType.productStripDeals;
  sliceIndex?: number;
  title?: string;
  /** Merch-set stack order when a PLP has more than one strip; lowest renders first. */
  display_order?: number | null;
  /** Comma-separated PLP category paths this strip displays on. */
  paths?: string | null;
  items: ProductStripDealsItem[];
}

export enum RedesignType {
  productStripDeals = 'product_strip_deals',
}
